// extracted by mini-css-extract-plugin
export default {"link":"NFTMarketplace_link__jbf45"};